export default {
  status: {
    open: 'Open',
    closed: 'Gesloten',
  },
  offline_until: 'Offline tot',
  closed_until: 'Gesloten tot',
  online_orders_paused: 'Online bestellingen gepauzeerd',
  online_orders_paused_until: 'Online bestellingen gepauzeerd tot',
  reopens: 'Heropent',
  opens_today: 'Opent vandaag',
  opens: 'Opent',
  open: 'Open',
  open_whole_day: 'De hele dag open',
  outside_ordering_times: 'Buiten besteltijden',
};
